import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GS1NotificationLevel, GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
import { CodeOrder } from '../models/code-order.model';
const __URL_API__ = `${environment.URL_API}`;

@Injectable({ providedIn: 'root' })
export class CustomerServiceService {
  private _http = inject(HttpClient);
  private notificationService = inject(GS1NotificationService);
  private translate = inject(TranslateService);

  unsubscribe(data: any): Observable<any> {
    return this._http.post(`${__URL_API__}api/clientservice/unsubscribe `, data).pipe(
      tap(() => this.sendNotif(this.translate.instant('Unsubscribe.Notification.success'), 'success', 15000)),
      catchError((err) => {
        this.sendNotif(this.translate.instant('Unsubscribe.Notification.error'), 'error');
        console.error(err);
        return of(null);
      })
    );
  }

  orderCode(data: FormData, isCB?: boolean): Observable<any> {
    return this._http.post(`${__URL_API__}api/clientservice/requestCode `, data).pipe(
      tap(() => {
        if (!(isCB && isCB === true)) {
          switch (data.get('typeCode')) {
            case 'UPC':
              this.sendNotif(this.translate.instant('Codes.Ordering.success-UPC'), 'success');
              break;
            case 'PVAR':
              this.sendNotif(this.translate.instant('Codes.Ordering.success-PVAR'), 'success');
              break;
            case 'GTIN8':
              this.sendNotif(this.translate.instant('Codes.Ordering.success-GTIN8'), 'success');
              break;
            case 'GCP':
              this.sendNotif(this.translate.instant('Codes.Ordering.success-GCP'), 'success');
              break;
            default:
              break;
          }
        }
      }),
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }
  validateOrder(id: string): Observable<void> {
    return this._http.get<void>(`${__URL_API__}api/clientservice/Validated/${id} `).pipe(
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }
  transferCodes(dataForm: FormData): Observable<any> {
    return this._http.post(`${__URL_API__}api/clientservice/transfer `, dataForm).pipe(
      tap(() => this.sendNotif(this.translate.instant('Transfer.Step4.success'), 'success')),
      catchError((err) => {
        this.sendNotif(this.translate.instant('Transfer.Step4.error'), 'error');
        console.error(err);
        return of(null);
      })
    );
  }
  createStandard(dataForm: FormData): Observable<any> {
    return this._http.post(`${__URL_API__}api/clientservice/requestStandard `, dataForm).pipe(
      tap(() => this.sendNotif(this.translate.instant('Standard.success'), 'success')),
      catchError((err) => {
        this.sendNotif(this.translate.instant('Standard.error'), 'error');
        console.error(err);
        return of(null);
      })
    );
  }
  getLastOrder(): Observable<{ order: CodeOrder }> {
    return this._http.get<{ order: CodeOrder }>(`${__URL_API__}api/clientservice/lastorder `).pipe(
      catchError((err) => {
        this.sendNotif(this.translate.instant('Erreur'), 'error');
        console.error(err);
        return of(null);
      })
    );
  }

  private sendNotif(message: string, level: GS1NotificationLevel, timeInMs = 10000) {
    this.notificationService.addNotification(message, level, timeInMs);
  }
}
